// Web Component: MainCustom
// Gestisce il flusso di personalizzazione prodotto tramite Vue, inclusi step, proprietà e immagini.
// Attributi richiesti: data-image, data-url
// Dipendenze: Vue, axios, presenza di #custom-data e #custom-product-form
// Limiti: richiede struttura HTML compatibile e dati JSON corretti
// Utilizzato nelle pagine di personalizzazione prodotto
class MainCustom extends HTMLElement {

  connectedCallback() {
    const script = this.querySelector('#custom-data');
    const data = JSON.parse(script.textContent);
    script.remove();
    const element = this;
    const imageUrl = this.dataset.image.split('?')[0].split('/').slice(0, -1).join('/');
    const form = document.querySelector('#custom-product-form');
    const themeForm = form.closest('theme-form');

    const app = Vue.createApp({
      delimiters: ['${', '}'],
      data() {
        return {
          properties: {},
          results: {},
          url: element.dataset.url,
          steps: data.steps,
          prev: null,
          canContinue: false,
          propSelected: null,
          images: [],
          visibleProperties: [],
          step: data.steps[0],
          text: '',
          formdata: [],
          variant: null,
          message: data.message
        }
      },
      methods: {
        fetch: function () {
          axios({
            url: this.url,
            method: 'GET'
          }).then(r => {
            this.properties = r.data.props;
            this.results = r.data.results;
            this.getProp();
          });
        },
        getProp (){
          this.visibleProperties = Array.from(this.properties).filter(prop => {
            return prop.type == this.step.key && (this.prev == null || prop.prev == this.prev);
          }); 
        },
        getImages() {
          this.images = Array.from(this.results).find(res => {
            return res.prev == this.prev;
          }).images;
        },
        getImageUrl(image) {
          return `${imageUrl}/${image}?width=500&v=3784937893`;
        },
        getName(name) {
          return `properties[${name}]`;
        },
        getId(prop, index){
          return `prop-${prop.type}-${index}`;
        },
        setSelected(prop) {
          this.propSelected = prop;
          this.canContinue = true;
        },
        setVariant() {
          this.canContinue = true;
        },
        setFormData(index) {
          const d = {
            name: `properties[${this.step.name}]`
          };
          if(this.step.type == 'props'){
            d.value = this.propSelected.title;
          }
          else if(this.step.type == 'input') {
            d.value = this.text;
          }
          else if(this.step.type == 'variants') {
            d.value = this.variant;
            d.name = 'id';
          }
          this.formdata[index] = this.step.type == 'result' ? null: d;
        },
        setActive(index) {
          this.setFormData(index-1);
          this.step = this.steps[index];
          this.canContinue = false;
          if(this.propSelected != null){
            this.prev = this.propSelected.handle;
            this.propSelected = null;
          }
          if(this.step.type == 'props')
            this.getProp();
          else if(this.step.type == 'result')
            this.getImages();
          else if(this.step.type == 'input')
            this.checkText();
        },
        checkText(){
          this.canContinue = this.text.length == 0 || (this.text.length >= this.step.min_length && this.text.length <= this.step.max_length);
          this.message = this.message.replace("{{ min }}", this.step.min_length).replace("{{ max }}", this.step.max_length);
        },
        addToCart() {
          this.setFormData(this.steps.length-1);
          const formData = new FormData();
          this.formdata.forEach(d => {
            if(d != null)
              formData.append(d.name, d.value);
          });
          Utils.addTocart({
            form: form,
            data: formData
          });
        },
        backTo(index){
          if(this.steps[index] != this.step){
            this.step = this.steps[index];
            this.canContinue = false;
            this.prev = this.step.prev;
            this.getProp();
          }
        }
      },
      mounted () {
        this.fetch();
      }
    });
    app.config.compilerOptions.isCustomElement = (tag) => {
      return tag == 'theme-swiper' || tag == 'theme-swiper-breakpoint' || tag == 'input-text' || tag == 'theme-form';
    };
    app.mount(this);
  }

}
if (!customElements.get('main-custom')) {
  customElements.define('main-custom', MainCustom);
}